const THOUSANDS = /\B(?=(\d{3})+(?!\d))/g;

export const MIN_DISBURSEMENT_QUERY_AMOUNT = 0.00
export const MAX_DISBURSEMENT_QUERY_AMOUNT = 99999999999.99

export function formatAmount(amount, decimalPlaces) {
    if (decimalPlaces === null || typeof decimalPlaces === 'undefined') {
        decimalPlaces = 2;
    }
    let numberAmount = Number(amount).toFixed(decimalPlaces);
    let num_parts = numberAmount.toString().split(".");
    num_parts[0] = num_parts[0].replace(THOUSANDS, ",");
    return num_parts.join(".");
}

export function formatDollarAmount(amount) {
    return "$" + formatAmount(amount, 2);
}

// uses regex to ensure user is typing in a dollar amount
export function formatInputAmount(amount) {
    // Make sure only numbers and decimals are typed in
    let dollarAmount = amount.replace(/[^0-9.]/g, '')

    // Truncate everything after 2 decimal points
    if (dollarAmount.includes('.')) {
        dollarAmount = dollarAmount.slice(0, (dollarAmount.indexOf(".")) + 3)
    }

    return dollarAmount
}

// Ensures the data-testid attribute follows html standards
export function formatTestId(testId) {
    // Make text lowercase
    let formattedTestId = testId.toLowerCase()

    // Replace spaces with hyphens
    formattedTestId = formattedTestId.replace(/\s+/g, '-')

    // Remove special characters (except '-' and '_')
    // eslint-disable-next-line no-useless-escape
    formattedTestId = formattedTestId.replace(/[`~!@#$%^&*()|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '')

    return formattedTestId
}

export function calculateDisplayPayments(pageSize, selectedPage, paymentList) {
    const data = paymentList;
    const startingElement = (pageSize * (selectedPage - 1));
    if (data) {
        if (data.length > startingElement) {
            const array = data.slice(startingElement, startingElement + pageSize);
            return array;
        }
        return data;
    }

    return [];
}

export function formatPhoneNumber(phoneNumber) {
    phoneNumber = phoneNumber.replace(/[()-.]/gi, '');
    return phoneNumber.substring(0, 3) + "-" + phoneNumber.substring(3, 6) + "-" + phoneNumber.substring(6, 10);
}

export function getUrl(companyNumber, path) {
    if (!path.startsWith('/')) {
        path = '/' + path;
    }
    return `/company/${companyNumber}${path}`
}